import { useState } from 'react'
import { Input } from '~/components/common/CurieInput'
import { EyeInvisible, EyeVisible } from '../../assets/icons'

interface PasswordInputProps {
  id?: string
  placeholder?: string
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  defaultValue?: string
  className?: string
  autoComplete?: string
  type?: 'email' | 'password' | 'text'
  autoFocus?: boolean
  disabled?: boolean
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  height?: 'sm' | 'md' | 'lg'
}

const PasswordInput = ({
  id,
  placeholder,
  value,
  onChange,
  defaultValue,
  className = '',
  type: _inputType = 'text',
  autoComplete = 'off',
  autoFocus = false,
  disabled = false,
  onBlur,
  height = 'md'
}: PasswordInputProps) => {
  const [visible, setVisible] = useState(false)

  return (
    <div className='relative w-full'>
      <Input
        id={id}
        placeholder={placeholder}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        onBlur={onBlur}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        disabled={disabled}
        type={visible ? 'text' : 'password'}
        height={height}
        className={`${className} bg-white w-full text-base pr-[48px]`}
      />
      <button
        type='button'
        onClick={() => setVisible(v => !v)}
        className='absolute right-6 top-1/2 transform -translate-y-1/2 text-gray-500'
        aria-label={visible ? 'Hide password' : 'Show password'}
      >
        {visible ? (
          <EyeVisible className='w-[18px] h-[18px] transform text-[rgba(0,0,0,0.25)] rotate-180' />
        ) : (
          <EyeInvisible className='w-[18px] h-[18px] transform text-[rgba(0,0,0,0.25)] rotate-180' />
        )}
      </button>
    </div>
  )
}

export default PasswordInput
